import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DropdownModule } from '../../../dropdown/dropdown.module';
import { InputUploadFilesComponent } from '../../../file-manage/input-upload-files/input-upload-files.component';
import { Subject, takeUntil } from 'rxjs';
import { StorageFile } from 'src/app/shared/models/storage';
import { DropdownOption } from '../../../dropdown/dropdown-primary/dropdown.interface';
import { ImportFuelCardService } from '../../../../api-services/import-fuel-card.service';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { CommunicationService } from 'src/app/shared/utilities/comunication.service';
import * as RoutesUrl from 'src/app/shared/constant/app-routes';
import {
  FuelCardType,
  CreateImportFuelCardTypeRequest,
  ItemImportFuelCardFileModel,
} from 'src/app/shared/models/import-fuel-card/import';

@Component({
  selector: 'app-upload-fuel-card',
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    DropdownModule,
    InputUploadFilesComponent,
  ],
  templateUrl: './upload-fuel-card.component.html',
  styleUrl: './upload-fuel-card.component.scss',
})
export class UploadFuelCardComponent implements OnInit, OnDestroy {
  fuelCardImporterOptions: DropdownOption[];
  selectedFuelCardType: DropdownOption;

  listFuelCardTypes: FuelCardType[];
  fuelCardType: FuelCardType;

  import: ItemImportFuelCardFileModel;

  file: StorageFile;
  bucketName: string = 'file-imports';

  statusModal = {
    canUplaod: false,
    canImport: false,
  };

  importForm: FormGroup;

  private _destroy = new Subject<void>();

  constructor(
    private _importService: ImportFuelCardService,
    private _communicationService: CommunicationService,
    private _toastrService: ToastrService,
    private _translateService: TranslateService,
    private _router: Router,
    public bsModalRef: BsModalRef
  ) {
    this.importForm = new FormGroup({
      name: new FormControl('', Validators.required),
    });
  }

  ngOnInit(): void {
    this.getListTypeImporters();
  }

  private getListTypeImporters() {
    this._importService
      .listfuelCardTypes$()
      .pipe(takeUntil(this._destroy))
      .subscribe({
        next: (response) => {
          this.listFuelCardTypes = response.items;
          this.fuelCardImporterOptions = response.items
            .map((fuelCardType) => {
              return {
                value: fuelCardType.name,
                text: fuelCardType.name,
              };
            })
            .sort((a, b) => a.text.localeCompare(b.text));
        },
      });
  }

  onSelectedTypeImporter($event: DropdownOption) {
    this.selectedFuelCardType = $event;
    this.fuelCardType = this.listFuelCardTypes.find(
      (fuelCardType) => fuelCardType.name === $event.value
    );
    if (this.fuelCardType) {
      this.file = null;
      this.statusModal.canUplaod = true;
      this.statusModal.canImport = false;
      this.importForm.reset();
    }
  }

  addPendingFile($event: StorageFile) {
    this.file = $event;
    this.importForm.get('name').setValue(this.file.name);
    this.statusModal.canImport = true;
  }

  createImport() {
    if (this.file) {
      let request: CreateImportFuelCardTypeRequest = {
        fuelCardTypeId: this.fuelCardType.id,
        name: this.importForm.value.name ?? this.file.name,
        sourceFileId: this.file.id,
      };
      this._importService.createImport$(request).subscribe({
        next: (response) => {
          this.import = response;
          this._router.navigate([RoutesUrl.IMPORTS], {
            queryParams: { activeTab: 'fuel-cards' },
          });
          this._toastrService.success(
            this._translateService.instant('IMPORT.MESSAGES.IMPORT_SUCCESS')
          );
          this._communicationService.sendEvent();
          this.bsModalRef.hide();
        },
      });
    }
  }

  ngOnDestroy(): void {
    this._destroy.next();
    this._destroy.complete();
  }
}
